export default __webpack_public_path__ + "media/images/banners/bnr_oita-35c25b8acf7c83685d487bd2e2d31fec.png";